import React, { FC, useContext, useEffect } from 'react';
import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import MeuConsumptionContext from '../../../../contexts/MeuConsumptionContext';
import { REPORT_PERIOD_SELECT } from '../../../../shared/SegmentEvents';
import { ConsolidatedHeaderComponent } from '../../components/Metrics/ConsolidatedHeader/ConsolidatedHeaderComponent';
import { PageHeaderComponent } from '../../components/Metrics/PageHeader/PageHeaderComponent';
import { MeuConsumptionPaper, MeuConsumptionConsolidatedRow, MeuConsumptionConsolidatedContent } from '../styles';
import { trackEvent } from '../../../../api/Billing/Tracking';
import { BlipLoadingComponent } from '../../../../components/BlipLoading/BlipLoadingComponent';
import { BillingMetrics } from '../../../../shared/BillingMetrics';

const MeuConsumptionConsolidatedInformationsComponent: FC = () => {
  const {
    currentMonth,
    content,
    tenant,
    dateToSearch,
    periodOptions,
    trackingProps,
    setDateToSearch,
    loggedUser,
    getPlanStatus,
    hasEnabledMetric,
    compiledMeuConsumptionDataState,
    isMeuLoading,
    consolidatedMeuApiRequisition,
    meuMetricIds,
  } = useContext(MeuConsumptionContext);
  const consolidatedMeuConsumption = compiledMeuConsumptionDataState.consolidatedMeuConsumption;

  const consolidatedContainsDataOnSelectedMonth =
    compiledMeuConsumptionDataState.consolidatedContainsDataOnSelectedMonth;

  const meuItem = consolidatedMeuConsumption.find(
    (item) => item.metric.metricId === BillingMetrics.monthlyEngagedUser
  );

  const msgItem = consolidatedMeuConsumption.find(
    (item) => item.metric.metricId === BillingMetrics.activeMessage
  );

  const totalMeu = meuItem ? meuItem.total : undefined;
  const totalMsg = msgItem ? msgItem.total : undefined;

  useEffect(() => {
    consolidatedMeuApiRequisition(dateToSearch, meuMetricIds, hasEnabledMetric);
  }, [dateToSearch]);

  const periodOptionChangeEvent = async (selectedOption) => {
    const dateToRetrieveData = new Date(selectedOption.detail.value);
    setDateToSearch(dateToRetrieveData);
    const planStatus = await getPlanStatus();
    trackEvent(REPORT_PERIOD_SELECT, tenant, loggedUser, {
      ...trackingProps,
      date: dateToRetrieveData,
      planStatus: planStatus,
    });
  };

  return (
    <>
      <PageHeaderComponent
        title={content.title}
        dateToSearch={dateToSearch}
        periodOptions={periodOptions}
        periodOptionChangeEvent={periodOptionChangeEvent}
      />
      <MeuConsumptionPaper>
        <div>
          <ConsolidatedHeaderComponent
            infoHeader={content.consolidated.plan}
            dateToSearch={dateToSearch}
            currentMonth={currentMonth}
            middleInfoContent={content.consolidated.middleInfo}
          />
          {isMeuLoading ? (
            <BlipLoadingComponent />
          ) : (
            <MeuConsumptionConsolidatedRow>
              {isMeuLoading ? (
                <BlipLoadingComponent />
              ) : (
                <>
                  {totalMeu >= 0 && (
                    <MeuConsumptionConsolidatedContent currentMonth={currentMonth} className="bg-color-surface-2">
                      <BdsTypo margin={true} bold="bold" variant="fs-16">
                        {content.consolidated.totalMiu}
                      </BdsTypo>
                      <BdsTypo
                        variant="fs-32"
                        bold="extra-bold"
                        margin={false}
                        data-totalMeu={totalMeu}
                        className={currentMonth ? 'color-content-default' : 'color-primary'}
                      >
                        {consolidatedContainsDataOnSelectedMonth ? totalMeu.toLocaleString(content.locale) : '--'}
                      </BdsTypo>
                    </MeuConsumptionConsolidatedContent>
                  )}
                  {totalMsg >= 0 && (
                    <MeuConsumptionConsolidatedContent currentMonth={currentMonth} className="bg-color-surface-2">
                      <BdsTypo margin={true} bold="bold" variant="fs-16">
                        {content.consolidated.totalMsg}
                      </BdsTypo>
                      <BdsTypo
                        variant="fs-32"
                        bold="extra-bold"
                        margin={false}
                        data-totalMsg={totalMsg}
                        className={currentMonth ? 'color-content-default' : 'color-primary'}
                      >
                        {consolidatedContainsDataOnSelectedMonth ? totalMsg.toLocaleString(content.locale) : '--'}
                      </BdsTypo>
                    </MeuConsumptionConsolidatedContent>
                  )}
                </>
              )}
            </MeuConsumptionConsolidatedRow>
          )}
        </div>
      </MeuConsumptionPaper>
    </>
  );
};

export default MeuConsumptionConsolidatedInformationsComponent;
